import type { ConfigurationMap } from '../auth-config-types'
import { defaultConfig } from './default.config'
import { preproductionConfig } from './preproduction.config'
import { productionConfig } from './production.config'

/**
 * Main configuration map aggregating all environment configurations
 */
export const configurationMap: ConfigurationMap = {
	Preproduction: preproductionConfig,
	Production: productionConfig,
	DEFAULT: defaultConfig,
}
